// import store from '@/store/index'
import CryptoJS from 'crypto-js'
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 * 
 */
 export const sysConstant = {
  FTP_PATH_APPLY:'apply',//申请模块
  FTP_PATH_NEWS:'news',//新闻模块
  FTP_PATH_SUPERVISION:'supervisionrecord',//后续监管模块
  FTP_PATH_USAGE:'usage',//使用记录模块
  FTP_PATH_MESSAGE:'warningmessage', //消息模块
  FTP_PATH_ENT:'ent',//企业模块
  FTP_PATH_SYS_UPLOAD_CUSTOM:'sysuploadcustom',//系统管理-上传附件配置
  FTP_PATH_DEFAULTS:'defaults'//默认路径
 }

//海关联网核查事项代码
export const customsConstant = {
  CN_MANDATORY_CERTIFICATE:'411',
  NO_HANDLE_CERTIFICATE:'410'
} 
export const applyStatus = {
  APPLY_STATUS_UNSUBIT:'01',//未提交
  APPLY_STATUS_FIRST_APPROVE:'02',//初审中
  APPLY_STATUS_REVIEW_APPROVE:'03',//复审中
  APPLY_STATUS_APPROVE_FAIL:'04',//审核不通过
  APPLY_STATUS_CORRECT:'05', //补正，退回企业
  APPLY_STATUS_CERT_MAKE:'31',//发证中
  APPLY_STATUS_CERT_DONE:'06',//已发证
  APPLY_STATUS_UPDATE_CERT_APPROVE:'07',//修改证明（审核中）
  APPLY_STATUS_UPDATE_CERT_PASS:'08',//修改证明（已通过）
  APPLY_STATUS_UPDATE_CERT_FAIL:'09'//修改证明（不通过）
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')
    .replace(/\+/g, ' ') +
    '"}'
  )
}

// AES加密

// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse("5163334867580164");
const IV = CryptoJS.enc.Utf8.parse('9269406277926375');
/**
 * AES加密 ：字符串 key iv  返回base64 
 */
export function Encrypt(word, keyStr, ivStr) {
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  // //console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

}
/**
 * AES 解密 ：字符串 key iv  返回base64 
 *
 */
export function Decrypt(word, keyStr, ivStr) {
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
// pdf预览
export function ExportPDF(res,certNo) {
  const blob = new Blob([res.data], {
    type: 'application/pdf'
  })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    let fileName = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
    if(typeof(certNo)=="undefined")
      certNo="temp"
    window.navigator.msSaveOrOpenBlob(blob, certNo+".pdf");
  } else{
    let pdfUrl = window.URL.createObjectURL(blob)
    window.open(pdfUrl)
  }

}
// excel文件下载
export function downloadExcel(res) {
//console.log(res)
  const blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel'
  })
  let temp = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
  let fileName = decodeURIComponent(temp)
  // //console.log(fileName)
  // 创建一个超链接，将文件流赋进去，然后实现这个超链接的单击事件
  const elink = document.createElement("a");
  elink.download = fileName;
  elink.style.display = "none";
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href); // 释放URL 对象
  document.body.removeChild(elink);
}

// 判断list是否否为空
export function judgeObjectComplete(ObjectValue, arr) {
  let flag = new Boolean()
  flag = true
  for (let key in ObjectValue) {
    for (let i =0; i<arr.length; i++) {
      if (key == arr[i]) {
        if (ObjectValue[key]) {
        } else {
          flag = false
        }
      }
    }

  }
  if (!flag) {
    return false
  } else {
    return true
  }
}
export function judgeListComplete(list, arr) {

  let isNotComplete = list.findIndex(item => {
    return judgeObjectComplete(item, arr) === false
  })
  if (isNotComplete > -1) {
    return false
  } else {
    return true
  }
}


import { Loading } from 'element-ui'
let loadingInstance = null
let loadingCount = 0
export const openLoading = function(val) {
  loadingInstance = Loading.service({ text:val|| '加载中,请稍后...', 'background': 'rgba(0, 0, 0, 0.19)' })

  loadingCount++
}
export const closeLoading = function() {
  loadingCount--
  if (loadingCount == 0) {
    loadingInstance.close()
  }
}


